import { Globe, ShieldCheck, BarChart, Users, Briefcase, BrainCircuit, Cpu, Database, LineChart, Cog } from "lucide-react";

const serviceConfig = [
  {
    slug: "market-entry-strategy",
    key: "marketEntry",
    icon: Globe,
    color: "text-blue-500",
    bgColor: "bg-blue-500/10",
    keywords: "US market entry strategy, healthcare market expansion, international market access, go-to-market healthcare, cross-border healthcare strategy, market entry consulting HealthTech",
  },
  {
    slug: "regulatory-navigation",
    key: "regulatory",
    icon: ShieldCheck,
    color: "text-green-500",
    bgColor: "bg-green-500/10",
    keywords: "FDA regulatory consulting, 510(k) clearance consulting, medical device regulatory pathway, healthcare regulatory navigation, FDA submission strategy, regulatory compliance healthcare",
  },
  {
    slug: "business-development",
    key: "bizDev",
    icon: BarChart,
    color: "text-purple-500",
    bgColor: "bg-purple-500/10",
    keywords: "healthcare business development, revenue growth healthcare, sales strategy MedTech, healthcare market penetration, Biotech business growth, healthcare sales consulting",
  },
  {
    slug: "strategic-partnerships",
    key: "partnerships",
    icon: Users,
    color: "text-orange-500",
    bgColor: "bg-orange-500/10",
    keywords: "healthcare strategic partnerships, joint ventures healthcare, licensing agreements MedTech, healthcare distribution partners, alliance strategy healthcare, partnership deal structuring",
  },
  {
    slug: "executive-advisory",
    key: "advisory",
    icon: Briefcase,
    color: "text-red-500",
    bgColor: "bg-red-500/10",
    keywords: "healthcare executive advisory, C-suite consulting healthcare, board advisory services, healthcare leadership consulting, strategic advisory HealthTech, senior management consulting",
  },
  {
    slug: "innovation-consulting",
    key: "innovation",
    icon: BrainCircuit,
    color: "text-teal-500",
    bgColor: "bg-teal-500/10",
    keywords: "healthcare innovation consulting, MedTech innovation strategy, healthcare product development, clinical innovation advisory, healthcare technology innovation, R&D strategy consulting, Healthcare AI, Health AI, Medical AI",
  },
  {
    slug: "digital-strategy-innovation",
    key: "digitalStrategy",
    icon: Cpu,
    color: "text-cyan-500",
    bgColor: "bg-cyan-500/10",
    keywords: "digital health strategy, healthcare digital transformation, telehealth consulting, digital therapeutics strategy, health IT consulting, healthcare platform strategy, Healthcare AI, Health AI, Medical AI",
  },
  {
    slug: "data-management-governance",
    key: "dataGov",
    icon: Database,
    color: "text-amber-500",
    bgColor: "bg-amber-500/10",
    keywords: "healthcare data governance, clinical data management, health data compliance, HIPAA data strategy, healthcare data quality, real-world data management healthcare, Healthcare AI, Health AI, Medical AI",
  },
  {
    slug: "advanced-analytics",
    key: "analytics",
    icon: LineChart,
    color: "text-indigo-500",
    bgColor: "bg-indigo-500/10",
    keywords: "healthcare advanced analytics, predictive analytics healthcare, clinical analytics consulting, health outcomes analytics, healthcare data science, population health analytics, Healthcare AI, Health AI, Medical AI",
  },
  {
    slug: "intelligent-automation",
    key: "automation",
    icon: Cog,
    color: "text-emerald-500",
    bgColor: "bg-emerald-500/10",
    keywords: "healthcare intelligent automation, RPA healthcare, AI healthcare consulting, clinical workflow automation, healthcare process optimization, machine learning healthcare applications, Healthcare AI, Health AI, Medical AI",
  },
];

export { serviceConfig };
